import _ from "lodash";
import * as z from "../../framework";
import { CompanyData, events } from "../../framework";
import { DropdownMenu } from "../../framework/components/components/dropdownMenu";
import { areGridsEditable } from "../../framework/dataComponents/components";
import * as searchOptions from "../../framework/dataComponents/searchOptions";
import { areNotificationsEnabled } from "../admin/notifications/notificationsConfig";
import { injectAnalytics } from "../analytics/analytics";
import { trackLogin } from "../analytics/churnZero";
import { ajax, attachAjaxHandlers } from "./ajax";
import * as brand from "./brand";
import About from "./common/admin/about";
import Report from "./common/report";
import * as core from "./core";
import Downtime from "./downtime";
import * as ui from "./ui";
import * as codes from "./util/codes";
import * as errorCode from "./util/errorCode";
import * as fieldVisibility from "./util/fieldVisibility";
import * as llRefresh from "./util/llRefresh";
import { calculateCookieExp, setCrossSubDomainCookie } from "./util/util";
import {
    getMyAccessibleRegions,
    defaultRegionIsGlobalRegion
} from "../../framework/core/division.region";
function displayError(err): void {
    let error: any;
    if (_.has(err, "responseJSON.Errors.General")) {
        error = err.responseJSON.Errors.General[0];
    }
    if (error !== undefined) {
        delete error.Data;
        delete error.Details;
        delete error.Source;
        delete error.InnerException;

        const {
            correlationId,
            correlationGroupId,
            requestUrl,
            status,
            statusText
        } = err;
        console.error(
            JSON.stringify(
                {
                    ...error,
                    correlationId,
                    correlationGroupId,
                    requestUrl,
                    status,
                    statusText
                },
                null,
                4
            )
        );
    }
}

export function loadPage(callback, removeLoadingAnimationManually?: boolean) {
    attachAjaxHandlers();
    injectAnalytics();

    // Put z on the window object for debugging purposes, and so
    // kendo templates have access.
    _.assign(window.z, z);

    searchOptions.registerComponents(ui);
    initialize()
        .done(function () {
            callback();

            if (removeLoadingAnimationManually) {
                return;
            }

            kendo.bind($(".bind-label"), z.LocalizedLanguage);

            $("#LoadingLogo").css("opacity", 0);

            $.wait(250).then(function () {
                $("#LoadingContainer").css("opacity", 0);
                $("#SiteContainer").fadeTo(750, 1, function () {
                    $("#LoadingLogo").hide();
                    $("#LoadingContainer").hide();
                });
            });

            if (localStorage.getItem("page-load-debugging")) {
                console.timeEnd("Total Page Load Time");
            }
        })
        .fail(function (err) {
            displayError(err);
            localStorage.clear();
            core.logout();
        });
}

export function initialize() {
    var deferred = $.Deferred();

    if (localStorage.getItem("page-load-debugging")) {
        console.time("Total Page Load Time");
    }

    $("#LoginLoader").fadeTo(750, 1);
    parseLocalStorage();
    brand.loadBranding();
    core.loadIdentityServerSettings();
    core.synchronizeAuthentication();

    selectCompany()
        .done(function () {
            loadData()
                .done(function () {
                    core.initializeCore();
                    afterDataLoaded();
                    deferred.resolve();
                })
                .fail(function () {
                    deferred.reject();
                });
        })
        .fail(function (err) {
            deferred.reject(err);
        });

    return deferred.promise();
}

var parseLocalStorage = function () {
    if (localStorage.loginData) {
        var loginData = $.parseJSON(localStorage.loginData);
        z.setToken(loginData.Token);
        z.settings.CompanyId = loginData.SelectedCompanyId;
    } else {
        const lsCompId = localStorage.getItem("Company-Id");
        const compId = parseInt(lsCompId, 10);
        if (isNaN(compId)) {
            core.logout();
        }
        z.settings.CompanyId = compId;
    }

    if (localStorage.companyData) {
        var companyData = $.parseJSON(localStorage.companyData);
        z.settings.companyVersion = companyData.CompanyVersionNumber;
    }
};

var selectCompany = function () {
    var me = this,
        urlPrefix = z.settings.appSettings.urlPrefix || "/service/api/",
        deferred = $.Deferred();

    localStorage.setItem("urlPrefix", urlPrefix);

    deferred.done(function () {
        z.settings.version = {};

        var remainder = z.settings.companyVersion || "";

        z.settings.version.major = parseInt(
            remainder.substring(0, remainder.indexOf(".")),
            10
        );
        remainder = remainder.substring(remainder.indexOf(".") + 1);

        z.settings.version.minor = parseInt(
            remainder.substring(0, remainder.indexOf(".")),
            10
        );
        remainder = remainder.substring(remainder.indexOf(".") + 1);

        z.settings.version.release = parseInt(
            remainder.substring(0, remainder.indexOf(".")),
            10
        );
        remainder = remainder.substring(remainder.indexOf(".") + 1);

        z.settings.version.build = parseInt(remainder, 10);
    });

    if (localStorage.isCompanySelected) {
        z.settings.companyVersion = localStorage.companyVersion;
        return deferred.resolve();
    }

    ajax({
        url: `User/SelectCompany/${z.settings.CompanyId}`,
        type: "POST",
        beforeSend: (xhr, options) => {
            const lsLastLoggedIn = localStorage.getItem(
                "LastLoggedInCompanyId"
            );
            const lastLoggedInCompanyId = parseInt(lsLastLoggedIn, 10);
            options.headers.CompanyId = lastLoggedInCompanyId;
            xhr.setRequestHeader("CompanyId", lastLoggedInCompanyId);
        }
    })
        .done(function (companyReponse) {
            localStorage.setItem(
                "LastLoggedInCompanyId",
                `${z.settings.CompanyId}`
            );
            let companyData: CompanyData = companyReponse.d.results;
            localStorage.setItem(
                "ScreensWithLookerDashboards",
                JSON.stringify(companyData.ScreensWithLookerDashboards)
            );

            const lsCompanyId = localStorage.getItem("Company-Id");
            const companyId = parseInt(lsCompanyId, 10);
            if (!isNaN(companyId)) {
                const lsLoginData = localStorage.getItem("loginData");

                // Grab information from the Employee Record
                z.ajax({
                    url:`Employee/${companyData.EmployeeId}`
                }).done(function (employeeData) {
                    let employee = employeeData.d.results;
                    if (lsLoginData) {
                        const loginData = JSON.parse(lsLoginData);
                        loginData.Companies[0] = {
                            CompanyName: companyData.CompanyName,
                            CompanyVersionNumber: companyData.CompanyVersionNumber,
                            Id: companyId,
                            IsMobile: false
                        };
                        loginData.FirstName = employee.FirstName;
                        loginData.LastName = employee.LastName;
                        loginData.FullName = `${employee.FirstName} ${employee.LastName}`
                        localStorage.setItem(
                            "loginData",
                            JSON.stringify(loginData)
                        );
                    } else {
                        const lsAuthResult = localStorage.getItem("authResult");
                        const lsAuthProfile = localStorage.getItem("authProfile");
                        const res = JSON.parse(lsAuthResult);
                        const tokenPayload = res.accessTokenPayload;
                        const ns = "https://servicepro10.com";
                        const prof = JSON.parse(lsAuthProfile);
                        const loginData = {
                            Companies: [
                                {
                                    CompanyName: companyData.CompanyName,
                                    CompanyVersionNumber:
                                        companyData.CompanyVersionNumber,
                                    Id: companyId,
                                    IsMobile: false
                                }
                            ],
                            FirstName: employee.FirstName,
                            FullName: `${employee.FirstName} ${employee.LastName}`,
                            LastName: employee.LastName,
                            SelectedCompanyId: companyId,
                            Token: tokenPayload[`${ns}/sid`],
                            UserId: tokenPayload[`${ns}/uid`],
                            UserName: prof.email
                        };
                        z.setToken(loginData.Token);
                        localStorage.setItem(
                            "loginData",
                            JSON.stringify(loginData)
                        );
                    }
                });
            } else {
                localStorage.setItem("Company-Id", `${z.settings.CompanyId}`);
            }

            $.each(companyData.UserDefinedLists, function (index, list) {
                list.Values.unshift({
                    CodeNumber: "",
                    Id: -1,
                    Value: "",
                    Deleted: true,
                    IsDeleted: true,
                    SortOrder: 0
                });
            });

            localStorage.companyData = JSON.stringify(companyData);
            localStorage.isCompanySelected = true;

            // Track Login due to the company data and auth profile being in local storage
            trackLogin(companyData);

            ajax({
                url: `${urlPrefix}User/GetVersionInfo`
            })
                .done(function (data) {
                    z.settings.companyVersion = localStorage.companyVersion =
                        data.d.results.CompanyTargetVersion;
                    deferred.resolve();
                })
                .fail(err => deferred.reject(err));
        })
        .fail(err => deferred.reject(err));

    return deferred.promise();
};

var loadData = function () {
    var companyData = $.parseJSON(localStorage.companyData),
        localeRequest,
        languagePreference = _.find(
            companyData.UserPreferences,
            function (userPreference: any) {
                return userPreference.UserPreferenceNumber == "Language";
            }
        );

    if (localStorage.getItem("page-load-debugging")) {
        console.time("Locale Request");
        console.time("Error Code Request");
        console.time("Codes Request");
        console.time("Vista Codes Request");
        console.time("Schema Request");
        console.time("Field Vis Request");
        console.time("User Email And Name Request");
        console.time("User Companies Request");
    }

    if (languagePreference) {
        localeRequest = z.loadJSONLocale(languagePreference.Value);
    } else if (companyData.Settings.DefaultLocale) {
        localeRequest = z.loadJSONLocale(companyData.Settings.DefaultLocale);
    } else {
        localeRequest = z.loadJSONLocale("en-us");
    }

    var errorCodeRequest = errorCode.buildErrorCodes(),
        codesRequest = codes.buildCodesRegistry(companyData.Options),
        vistaCodesRequest = codes.buildVistaCodesRegistry(
            _.find(companyData.Options, o => o.OptionNumber === "IsVista")
        ),
        schemaRequest = z.loadSchemaJson(),
        fieldVisRequest = fieldVisibility.loadCompanyFieldVisibility(),
        userEmailAndNameRequest = $.Deferred(),
        userCompaniesRequest = requestUserCompanies();

    z.userCache
        .loadUserCache()
        .then(x => userEmailAndNameRequest.resolve())
        .catch(x => userEmailAndNameRequest.reject());

    var logout = function (e) {
        displayError(e);
        var wasNotAuthorized = false;
        if (e.status == 401) {
            wasNotAuthorized = true;
        }
        core.logout(wasNotAuthorized);
    };

    if (localStorage.getItem("page-load-debugging")) {
        localeRequest.done(() => console.timeEnd("Locale Request"));
        errorCodeRequest.done(() => console.timeEnd("Error Code Request"));
        codesRequest.done(() => console.timeEnd("Codes Request"));
        vistaCodesRequest.done(() => console.timeEnd("Vista Codes Request"));
        schemaRequest.done(() => console.timeEnd("Schema Request"));
        fieldVisRequest.done(() => console.timeEnd("Field Vis Request"));
        userEmailAndNameRequest.done(() =>
            console.timeEnd("User Email And Name Request")
        );
        userCompaniesRequest.done(() =>
            console.timeEnd("User Companies Request")
        );
    }

    errorCodeRequest.fail(logout);
    codesRequest.fail(logout);
    vistaCodesRequest.fail(logout);
    schemaRequest.fail(logout);
    fieldVisRequest.fail(logout);

    return $.when(
        localeRequest,
        errorCodeRequest,
        codesRequest,
        vistaCodesRequest,
        schemaRequest,
        fieldVisRequest,
        userEmailAndNameRequest,
        userCompaniesRequest
    );
};

const requestUserCompanies = function () {
    let promise = $.Deferred<void>();
    let numOfCompaniesLS = localStorage.getItem("numOfCompanies");

    if (numOfCompaniesLS) {
        promise.resolve();
    } else {
        z.ajax({
            type: "GET",
            url: "User/UserCompanies"
        })
            .then(resp => {
                let companyLength = (resp.d.results as any[]).length;
                localStorage.setItem("numOfCompanies", `${companyLength}`);
                if (companyLength > 1) {
                    $("#SwitchTenantSeparator").removeClass("hidden");
                    $("#SwitchTenant").removeClass("hidden");
                }
                promise.resolve();
            })
            .fail(err => {
                localStorage.setItem("numOfCompanies", "1");
                promise.reject(err);
            });
    }

    return promise;
};

var bindScheduleBanner = function (): void {
    var scheduleEnabled = z.user.companyData.Settings.ScheduleEnabled,
        scheduleBanner = $("#ScheduleBanner"),
        link = $("#ScheduleBannerLink"),
        setLinkAttr = function (linkText: string, href: string): void {
            link.text(linkText);
            link.attr("href", href);
        };

    var schedulerPlusEnabled = z.util.getBooleanOption("IsSchedulerPlusEnabled", false),
        schedulerPlusBanner = $("#SchedulerPlusBanner"),
        schedulerPlusLink = $("#SchedulerPlusBannerLink"),
        setSchedulerLinkAttr = function (linkText: string, href: string): void {
            schedulerPlusLink.text(linkText);
            schedulerPlusLink.attr("href", href);
        },
        schedulerPlusEnabledRight = 'SCPLBS',
        hasSchedulerEnabledRight = _.includes(z.user.companyData.Rights, schedulerPlusEnabledRight);

    if (schedulerPlusEnabled && hasSchedulerEnabledRight) {
        setSchedulerLinkAttr(z.ll("SchedulerPlus"), "/SchedulerPlus");
        scheduleBanner.remove();
    }
    else if (scheduleEnabled) {
        setLinkAttr(z.ll("Scheduler"), "/Scheduler");
        schedulerPlusBanner.remove();
    } else {
        scheduleBanner.remove();
        schedulerPlusBanner.remove();
    }
};

let gridStickyDefaultsLoaded = false;
var afterDataLoaded = async function () {
    $("a.banner-link").parents("div.unskew").addClass("topBotomBordersIn");

    if (!localStorage.loginData || !localStorage.companyData) {
        core.logout();
        return;
    }

    if (
        !window.z.debuggerAttached &&
        z.config &&
        z.user &&
        z.user.name == "Automated Tests" &&
        z.user.company == "MSI Data - Selenium Tests"
    ) {
        z.config.defaultAlertDuration.success = 25000;
    }

    llRefresh.fixStoredll();
    var loginData = $.parseJSON(localStorage.loginData),
        companyData = $.parseJSON(localStorage.companyData),
        culture;

    if (companyData.Settings.CultureId) {
        culture = _.find(z.codes.Culture, function (item) {
            return item.Id == companyData.Settings.CultureId;
        });
    }

    if (culture) {
        kendo.culture(culture.Value);
    } else {
        kendo.culture("en-US");
    }

    _.assign(z.user, {
        name: loginData.FullName,
        company: companyData.CompanyName,
        loginData: loginData,
        companyData: companyData
    });

    Array.prototype.push.apply(z.rights, companyData.Rights);

    if (z.codes.Division) {
        z.user.myDivision = _.find(z.codes.Division || [], function (division) {
            return division.Id == z.user.companyData.EmployeeDivisionId;
        });
    }

    if (z.codes.Region) {
        z.user.myDefaultRegion = _.find(
            z.codes.Region || [],
            function (region) {
                return region.Id == z.user.companyData.EmployeeDefaultRegionId;
            }
        );

        getMyAccessibleRegions().then(accessibleRegions => {
            const defaultIsGlobal = defaultRegionIsGlobalRegion();
            z.user.myRegions = _.filter(
                z.codes.Region || [],
                r => _.includes(accessibleRegions, r.Id) || defaultIsGlobal
            );
        });
    }

    kendo.bind($("#UserInfo"), z.user);

    $("#initTimeout").remove();

    if (!gridStickyDefaultsLoaded) {
        z.util.loadGridStickyDefaults();
        gridStickyDefaultsLoaded = true;
    }

    z.extendll(z.user.loginData.LocalizedLabels);
    z.extendll(z.user.companyData.LocalizedLabels);

    if (window.z.debuggerAttached) {
        llRefresh.initllRefresh();
    }
    z.attachAjaxErrorMessageHandler();

    $("#SwitchTenant").text(z.ll("SwitchTenant"));

    $("#CallBannerLink").text(z.ll("BannerCall"));
    $("#OrderBannerLink").text(z.ll("BannerOrder"));
    $("#RMABannerLink").text(z.ll("BannerRMA"));
    $("#ContractBannerLink").text(z.ll("BannerContract"));
    $("#QuoteBannerLink").text(z.ll("BannerQuote"));
    bindScheduleBanner();

    $("#InspectionBannerLink").text(z.ll("BannerInspection"));
    $("#FinancialBannerLink").text(z.ll("BannerFinancial"));
    $("#CustomerBannerLink").text(z.ll("BannerCustomer"));
    $("#InventoryBannerLink").text(z.ll("BannerInventory"));
    $("#MaintenanceBannerLink").text(z.ll("BannerMaintenance"));
    $("#qUnitBannerLink").text(z.ll("BannerqUnit"));

    $("#reportLabel").text(z.ll("ReportsDrop"));
    $("#adminLabel").text(z.ll("AdminDrop"));
    $("#EmployeeBannerLink").text(z.ll("EmployeeBannerLink"));
    $("#RolesRightsBannerLink").text(z.ll("RolesRightsBannerLink"));

    if (
        z.settings.appSettings &&
        z.settings.appSettings.appName &&
        z.LocalizedLanguage.BrandedAboutInfo &&
        z.LocalizedLanguage.BrandedAboutInfo.indexOf(
            z.settings.appSettings.appName
        ) == -1
    ) {
        z.LocalizedLanguage.BrandedAboutInfo = `About ${z.settings.appSettings.appName}`;
    }
    $("#AboutServicePro").text(z.ll("BrandedAboutInfo"));

    kendo.bind("#Banner .bind-label", z.LocalizedLanguage);

    z.logHelper.init();

    var bottomUtils = $("#BottomUtilities");

    if (bottomUtils.length) {
        bottomUtils.html(
            '<ul id="ReportAdminBanner" class="nav navbar-nav navbar-right banner-menu"></ul>'
        );

        var menu = new DropdownMenu("#ReportAdminBanner", {
            direction: "bottom left",
            openOnClick: true,
            animation: {
                close: {
                    duration: 250
                }
            },
            select: function (event) {
                var senderId = event.item.id;
                if (senderId === "ShowErrorReport") {
                    z.logHelper.setUserData(z.logHelper.getUserData());
                    z.logHelper.buildLogPopUp();
                }
                if (senderId === "EditGrids") {
                    localStorage.setItem(
                        "EditGrids",
                        (!areGridsEditable()).toString()
                    );
                    window.location.reload(true);
                }
            }
        });

        menu.append([
            {
                classes: "banner-menu banner-menu-header",
                id: "ReportMenu",
                content: z.ll("Report")
            },
            DropdownMenu.VerticalSeparator({
                classes: "banner-menu",
                id: "menuVerticalSeparator"
            }),
            {
                classes: "banner-menu banner-menu-header",
                id: "AdminMenu",
                content: z.ll("AdminDrop")
            },
            ...(z.settings.brandName === "servicepro"
                ? [
                      DropdownMenu.VerticalSeparator({
                          classes: "banner-menu mar-l-10",
                          id: "menuVerticalSeparator"
                      }),
                      {
                          classes: "banner-menu banner-menu-header",
                          id: "Help",
                          content: z.ll("Help")
                      }
                  ]
                : [])
        ]);
    }

    if (z.settings.brandName === "servicepro") {
        $("#Help").on("click", function () {
            $("#Help").disable();

            z.ajax({
                url: "Help/GetCookies",
                dataType: "text"
            })
                .done(url => {
                    setTimeout(() => {
                        window.open(url, "_blank");
                        $("#Help").enable();
                    }, 1000);
                })
                .fail(() => $("#Help").enable());
        });
    }

    if (z.user && z.user.companyData && z.user.companyData.Options) {
        var iframeReportOption = null,
            iframeAdminOption = null;

        $.each(z.user.companyData.Options, function (index, option) {
            if (option.OptionNumber === "ReportDropDownIFrame") {
                iframeReportOption = option;
            } else if (option.OptionNumber === "AdminDropDownIFrame") {
                iframeAdminOption = option;
            }
        });

        var openIframe = function (optionValue) {
            $("#Main").children().addClass("hide-for-i-frame");
            $("#TopToolbar").addClass("hide-for-i-frame");
            $("#IFrameContainer").remove();

            var iframeContainer = $(
                    "<div class='i-frame-container' id='IFrameContainer'> <div class='close-i-frame-container'>x</div></div>"
                ),
                iframe = $("<iframe>", {
                    src: optionValue.url,
                    id: "IFrame",
                    frameborder: 0
                });

            iframe.appendTo(iframeContainer);
            iframeContainer.appendTo("#Main");

            $(".close-i-frame-container")
                .off()
                .tie("click", function () {
                    $("#Main").children().removeClass("hide-for-i-frame");
                    $("#TopToolbar").removeClass("hide-for-i-frame");
                    $("#IFrameContainer").remove();
                });

            $(window)
                .unbind("resize.iframe")
                .bind("resize.iframe", function () {
                    if (iframe) {
                        var resizeIFrame = function () {
                            var offset = $("#Main").offset().top,
                                height = $(window).height() - offset - 4,
                                width = $(window).width();

                            if (width < 979) {
                                width = 979;
                            }

                            if (height < 751) {
                                height = 751;
                            }

                            iframe.height(height);
                            iframe.width(width);
                            z.layout.resizeWindow();
                        };
                        $.wait(750).then(resizeIFrame);
                        resizeIFrame();
                    }
                });

            $(window).trigger("resize");

            $(".sp-logo-gray-tagline").hide();
        };

        if (iframeAdminOption) {
            var adminOptionValues = $.parseJSON(iframeAdminOption.Value);

            $.each(adminOptionValues, function (index, adminOptionValue) {
                menu &&
                    menu.append(
                        [
                            {
                                content: adminOptionValue.label,
                                classes:
                                    "banner-link banner-menu banner-menu-top-level",
                                id: `${adminOptionValue.label.replaceAll(
                                    " ",
                                    "_"
                                )}Link`
                            }
                        ],
                        "#AdminMenu"
                    );

                $(`#${adminOptionValue.label.replaceAll(" ", "_")}Link`).tie(
                    "click",
                    function () {
                        openIframe(adminOptionValue);
                    }
                );
            });
        }

        if (iframeReportOption) {
            var reportOptionValues = $.parseJSON(iframeReportOption.Value);

            $.each(reportOptionValues, function (index, reportOptionValue) {
                menu &&
                    menu.append(
                        [
                            {
                                content: reportOptionValue.label,
                                classes:
                                    "banner-link banner-menu banner-menu-top-level",
                                id: `${reportOptionValue.label.replaceAll(
                                    " ",
                                    "_"
                                )}Link`
                            }
                        ],
                        "#ReportMenu"
                    );

                $(`#${reportOptionValue.label.replaceAll(" ", "_")}Link`).tie(
                    "click",
                    function () {
                        openIframe(reportOptionValue);
                    }
                );
            });
        }
    }

    menu &&
        menu.append(
            [
                {
                    content: z.ll("Employees"),
                    classes: "banner-link banner-menu banner-menu-top-level",
                    id: "EmployeeBannerLink",
                    url: "/Employee"
                },
                {
                    content: z.ll("CustomerPortalTitle"),
                    classes: "banner-link banner-menu banner-menu-top-level",
                    id: "PortalBannerLink"
                },
                {
                    content: z.ll("Roles"),
                    classes: "banner-link banner-menu banner-menu-top-level",
                    id: "RolesRightsBannerLink",
                    url: "/Roles"
                },
                {
                    content: z.ll("Dashboards"),
                    classes: "banner-link banner-menu banner-menu-top-level",
                    id: "DashboardMaintenanceLink",
                    url: "/Dashboards"
                },
                {
                    content: z.ll("CF"),
                    classes: "banner-link banner-menu banner-menu-top-level",
                    id: "CustomFieldsLink",
                    url: "/CustomFieldMaintenance"
                },
                {
                    content: z.ll("Settings"),
                    id: "Settings",
                    classes: "banner-link banner-menu banner-menu-top-level",
                    url: "/Settings"
                },
                {
                    content: z.ll("CrossReferences"),
                    id: "CrossReferencesLink",
                    classes: "banner-link banner-menu banner-menu-top-level",
                    url: "/CrossReferences"
                },
                {
                    content: z.ll("FieldVisibility"),
                    id: "FieldVisibilityLink",
                    classes: "banner-link banner-menu banner-menu-top-level",
                    url: "/FieldVisibility"
                },
                {
                    content: z.ll("Notifications"),
                    id: "NotificationsLink",
                    classes: "banner-link banner-menu banner-menu-top-level",
                    url: "/Notifications"
                },
                {
                    content: z.ll("ErrorReport"),
                    id: "ShowErrorReport",
                    classes: "banner-link banner-menu banner-menu-top-level"
                },
                {
                    content: areGridsEditable()
                        ? z.ll("EditGridsOn")
                        : z.ll("EditGridsOff"),
                    id: "EditGrids",
                    classes: "banner-link banner-menu banner-menu-top-level"
                },
                DropdownMenu.HorizontalSeparator({ classes: "banner-menu" }),
                {
                    content: z.ll("BrandedAboutInfo"),
                    classes: "banner-link banner-menu banner-menu-top-level",
                    id: "AboutServicePro"
                }
            ],
            "#AdminMenu"
        );

    if (areGridsEditable()) {
        $("#EditGrids").addClass("active-module");
    }

    menu &&
        menu.append(
            [
                {
                    content: z.ll("CustomerPortalUsers"),
                    classes: "banner-link banner-menu",
                    id: "PortalUsersBannerLink",
                    url: "/PortalUsers"
                },
                {
                    content: z.ll("AccessCustomerPortal"),
                    classes: "banner-link banner-menu",
                    id: "AccessPortalBannerLink"
                }
            ],
            "#PortalBannerLink"
        );

    $("#AccessPortalBannerLink")
        .off()
        .tie("click", () => {
            const token = localStorage.getItem("IDSBearer");
            const companyId = localStorage.getItem("Company-Id");
            const numOfCompanies = localStorage.getItem("numOfCompanies");
            const exp = calculateCookieExp();
            setCrossSubDomainCookie("spToken", token, exp);
            setCrossSubDomainCookie("spCompanyId", companyId, exp);
            setCrossSubDomainCookie("spNumOfCompanies", numOfCompanies, exp);

            if (location.hostname === "localhost") {
                window.open(
                    `${location.protocol}//${location.hostname}:1884/continue`,
                    "_blank"
                );
            } else {
                window.open(
                    `${location.protocol}//portal.${location.hostname}/continue`,
                    "_blank"
                );
            }
        });

    z.controls.toolTip({
        content: areGridsEditable()
            ? z.ll("DisableEditGridsTooltip")
            : z.ll("EnableEditGridsTooltip"),
        alignX: "left",
        alignY: "center",
        alignTo: "target",
        offsetX: 5,
        selector: $("#EditGrids")
    });

    // This has to be after the menu gets appended to......
    if (localStorage.companyData) {
        companyData = $.parseJSON(localStorage.companyData);

        const portalEnabled = z.util.getBooleanOption("PortalEnabled", false),
            lookerEnabled = z.util.getBooleanOption("LookerEnabled", false),
            notificationsEnabled = await areNotificationsEnabled(),
            worksAtMsi =
                z.user.loginData.UserName.toLowerCase().endsWith(
                    "@msidata.com"
                );

        const bannerLinks = [
            { right: "RPXXBX", banner: "ReportMenu", show: true },
            {
                right: "ADCUBX",
                banner: "EmployeeBannerLink",
                show: companyData.Settings.AdminEnabled,
                endpoint: "Employee"
            },
            {
                right: null,
                banner: "PortalBannerLink",
                show: companyData.Settings.AdminEnabled && portalEnabled
            },
            {
                right: "ADPOBX",
                banner: "PortalUsersBannerLink",
                show: companyData.Settings.AdminEnabled && portalEnabled,
                endpoint: "PortalUsers"
            },
            {
                right: null,
                banner: "AccessPortalBannerLink",
                show: companyData.Settings.AdminEnabled && portalEnabled
            },
            {
                right: "ADCRBX",
                banner: "RolesRightsBannerLink",
                show: companyData.Settings.AdminEnabled,
                endpoint: "Roles"
            },
            {
                right: "ADDBBX",
                banner: "DashboardMaintenanceLink",
                show: companyData.Settings.AdminEnabled && lookerEnabled,
                endpoint: "Dashboards"
            },
            {
                right: "ADRFBX",
                banner: "CrossReferencesLink",
                show: companyData.Settings.AdminEnabled && worksAtMsi,
                endpoint: "CrossReferences"
            },
            {
                right: "ADFVBX",
                banner: "FieldVisibilityLink",
                show: companyData.Settings.AdminEnabled && worksAtMsi,
                endpoint: "FieldVisibility"
            },
            {
                right: "ADNTBX",
                banner: "NotificationsLink",
                show: companyData.Settings.AdminEnabled && notificationsEnabled,
                endpoint: "Notifications"
            },
            {
                right: "ADCSBX",
                banner: "CustomFieldsLink",
                show: companyData.Settings.AdminEnabled,
                endpoint: "CustomFieldMaintenance"
            },
            {
                right: "ADCFBX",
                banner: "Settings",
                show: companyData.Settings.AdminEnabled
            },
            {
                right: "CLXXBX",
                banner: "CallBanner",
                show: companyData.Settings.CallEnabled,
                endpoint: "Call"
            },
            {
                right: "ORXXBX",
                banner: "OrderBanner",
                show: companyData.Settings.OrderEnabled,
                endpoint: "Order"
            },
            {
                right: "RMXXBX",
                banner: "RMABanner",
                show: companyData.Settings.RMAEnabled,
                endpoint: "RMA"
            },
            {
                right: "CTXXBX",
                banner: "ContractBanner",
                show: companyData.Settings.ContractEnabled,
                endpoint: "Contract"
            },
            {
                right: "QTXXBX",
                banner: "QuoteBanner",
                show: companyData.Settings.QuoteEnabled,
                endpoint: "Quote"
            },
            {
                right: "FNXXBX",
                banner: "FinancialBanner",
                show: companyData.Settings.FinancialEnabled,
                endpoint: "Financial"
            },
            {
                right: "INXXBX",
                banner: "InventoryBanner",
                show: companyData.Settings.InventoryEnabled,
                endpoint: "Inventory"
            },
            {
                right: "SCXXBX",
                banner: "ScheduleBanner",
                show: companyData.Settings.ScheduleEnabled,
                endpoint: "Scheduler"
            },
            {
                right: "MNXXBX",
                banner: "MaintenanceBanner",
                show: companyData.Settings.MaintenanceEnabled,
                endpoint: "Maintenance"
            },
            {
                right: "CUXXBX",
                banner: "CustomerBanner",
                show: companyData.Settings.CustomerEnabled,
                endpoint: "Customer"
            },
            {
                right: "IPXXBX",
                banner: "InspectionBanner",
                show: companyData.Settings.InspectionEnabled,
                endpoint: "Inspection"
            },
            {
                right: "--",
                banner: "qUnitBannerLink",
                show: companyData.Settings.qUnitEnabled,
                endpoint: "qUnit"
            }
        ];

        var found = false;

        // Just remove qUnit banner since devs know where it is
        $("#qUnitBannerLink").remove();

        var shouldWeRouteTo403 = function (bannerLink) {
            var currentPath = window.location.pathname.toLowerCase(),
                url403Page = `${window.location.origin}/Error/_403`;

            if (
                bannerLink.endpoint &&
                currentPath.contains(bannerLink.endpoint.toLowerCase())
            ) {
                if (!bannerLink.show) {
                    window.location.href = url403Page;
                }
            }
        };

        $.each(bannerLinks, function (a, item) {
            const right = item.right;
            found =
                right == null ? true : _.includes(companyData.Rights, right);

            if (!found || !item.show) {
                $(`#${item.banner}`).remove();
                item.show = false;
            }

            shouldWeRouteTo403(item);

            // Trying to solve other bug
            $.wait(10).then(function () {
                shouldWeRouteTo403(item);
                $.wait(200).then(function () {
                    shouldWeRouteTo403(item);
                    $.wait(200).then(function () {
                        shouldWeRouteTo403(item);
                    });
                });
            });
        });

        if (
            $("#EmployeeBannerLink").length == 0 &&
            $("#CustomFieldsLink").length == 0
        ) {
            $("#AboutSep").remove();
        }

        if ($("#ReportMenu").length == 0) {
            $("#menuVerticalSeparator").remove();
        }
    }

    let reportManager = new Report(),
        aboutManager = new About(),
        downtimeManager = new Downtime();

    let exemptUsersFromSessionTimeout =
        z.util.getOptionValue("ExemptUsersFromSessionTimeout") || "";
    if (
        exemptUsersFromSessionTimeout
            .toLowerCase()
            .indexOf(z.user.loginData.UserName.toLowerCase()) == -1
    ) {
        inactivityTime();
    }
    events.fire(events.pageDoneLoading);
};

var inactivityTime = function () {
    let timeoutInMilliseconds =
        parseInt(z.util.getOptionValue("SessionTimeout") || "14400", 10) * 1000; // 4 hours
    let timeoutMessageLengthInMilliseconds =
        parseInt(
            z.util.getOptionValue("SessionTimeoutWarningDuration") || "60",
            10
        ) * 1000; // 60 seconds
    let userEvent = true;
    let timeout = setTimeout(() => resetTimer(!userEvent), 60000); // 1 minute checks
    let aboutToBeLoggedOut = false;
    let startTimeOfBeginLogout = new Date();
    localStorage.lastUserActivity = new Date().toISOString();
    resetTimer(userEvent);
    document.onmousemove = () => resetTimer(userEvent);
    document.onmousedown = () => resetTimer(userEvent);
    document.ontouchstart = () => resetTimer(userEvent);
    document.onclick = () => resetTimer(userEvent);
    document.onkeypress = () => resetTimer(userEvent);
    document.addEventListener("scroll", () => resetTimer(userEvent), true);
    window.addEventListener("focus", () => {
        resetTimer(!userEvent);
        resetTimer(userEvent);
    });
    document.addEventListener("visibilitychange", () => {
        resetTimer(!userEvent);
        resetTimer(userEvent);
    });

    function countDownTimer() {
        if (aboutToBeLoggedOut) {
            let now = new Date();
            let timeLeft = Math.ceil(
                (timeoutMessageLengthInMilliseconds -
                    (now.getTime() - startTimeOfBeginLogout.getTime())) /
                    1000
            );

            $("#TimeInSecondsUntilLogOut").text(timeLeft);

            if (timeLeft <= 0) {
                core.logout();
            }

            setTimeout(countDownTimer, 1000);
        }
    }

    function resetTimer(isUserEvent) {
        if (aboutToBeLoggedOut) {
            return;
        }

        clearTimeout(timeout);

        if (isUserEvent) {
            localStorage.lastUserActivity = new Date().toISOString();
        }

        let now = new Date();
        let lastUserActivityDate = new Date(localStorage.lastUserActivity);
        let inactiveTimeInMilliseconds =
            now.getTime() - lastUserActivityDate.getTime();

        if (inactiveTimeInMilliseconds >= timeoutInMilliseconds) {
            core.logout();
        } else if (
            inactiveTimeInMilliseconds >=
            timeoutInMilliseconds - timeoutMessageLengthInMilliseconds
        ) {
            aboutToBeLoggedOut = true;

            z.controls.popUp({
                id: "AboutToBeLoggedOut",
                classes: "about-to-be-logged-out-pop-up",
                width: 400,
                title: z.ll("YourSessionIsAboutToExpire"),
                keepContentBox: true,
                guts: `<div class="session-timeout-message"><span>${z
                    .ll("YourSessionIsAboutToExpireMessage")
                    .format(
                        `<b id="TimeInSecondsUntilLogOut">${
                            timeoutMessageLengthInMilliseconds / 1000
                        }</b>`
                    )}</span></div>`,
                actions: [],
                buttons: [
                    {
                        name: z.ll("LogOut"),
                        className: "left",
                        clickEvent: () => {
                            core.logout();
                        }
                    },
                    {
                        name: z.ll("WaitKeepMeLoggedIn"),
                        clickEvent: () => {
                            aboutToBeLoggedOut = false;
                            resetTimer(userEvent);
                        }
                    }
                ]
            });
            startTimeOfBeginLogout = new Date();
            setTimeout(countDownTimer, 1000);
        }

        let fireInXSeconds = 60000;
        let timeLeft =
            timeoutInMilliseconds -
            timeoutMessageLengthInMilliseconds -
            inactiveTimeInMilliseconds;

        if (timeLeft < fireInXSeconds) {
            fireInXSeconds = timeLeft;
        }

        timeout = setTimeout(() => resetTimer(!userEvent), fireInXSeconds);
    }
};
